import Validator from './Validate.js';
import {declOfNum, numberDivide} from './Util.js';


class Form {
    constructor(form) {
        this.$form = $(form);
        this.formValidate;
        this.$btn = this.$form.find('.js-submit');
        this.recaptcha;

        this.popLabels();
        this.validate();
        this.bindSubmit();
        this.bindClose();
        this.disableAutoFill();
        this.disableIEautocomplete();
        this.fileUpload();
        this.filterPhone();
        this.filterDigit();
        this.initClonable();
        this.singleselect();
        this.multiselect();
        this.areasum();
        this.bindRadioShowHide();
        this.bindSelectShowHide();
        this.bindSuccessPopup();
        this.renderFormState();

        if (App.recaptchaAvailable) {
            this.initRecaptcha();
        } else {
            this.spamCheck();
        }
        // this.spamCheck();
    }



    // Валидация
    validate() {
        this.formValidate = new Validator(this.$form);
    }



    // Инициализируем рекапчу
    initRecaptcha() {
        const $container = this.$form.find('.js-recaptcha');

        this.recaptcha = grecaptcha.render($container.attr('id'), {
            'sitekey': $container.data('sitekey'),
            'size': 'invisible',
            'callback': () => {
                this.sendForm();
            },
            'error-callback': () => {
                // Ошибка на стороне рекапчи
                this.$form
                    .removeClass('_success')
                    .addClass('_error');

                console.log('recaptcha error');
            }
        });
    }



    // Событие отправки
    bindSubmit() {
        this.$form.on('submit', (e) => {
            e.preventDefault();

            // Блокируем кнопку сабмита
            this.$btn.attr('disabled', true);

            // Запускаем проверку рекапчи
            if (App.recaptchaAvailable) {
                grecaptcha.execute(this.recaptcha);
            } else {
                this.sendForm();
            }
        });
    }



    // Отправка
    sendForm() {
        this.$form.find(`.js-input-seconds`).val(App.secondsOnPage);

        // блокируем от двойного нажатия
        this.$btn.prop('disabled', true);

        if (!this.formValidate.validateAllRequired()) {
            this.formValidate.calculateErrors();
            return false;
        }

        if (this.$form.hasClass('js-hotline-form')) {
            this.$form.removeClass('_not-found');
            this.$form.find('.js-hotline-empty').html('');
            $('.js-hotline-ticket').html('');
            $('.js-hotline-answer').removeClass('_shown');

            const code = $('.js-hotline-form').find('.js-input').val();
            $('.js-hotline-code-hidden').val(code);
        }

        //$.ajax({
        this.$form.ajaxSubmit({
            url: this.$form.attr('action'),
            dataType: 'json',
            //data: this.$form.serialize(),
            //data: formDataObj,
            type: this.$form.attr('method') || 'GET',
            cache: false,
            success: (response) => {
                if (!response.success) {
                    // Ошибка на сервере
                    this.$form
                        .removeClass('_success')
                        .addClass('_error');
                    App.H
                        .removeClass('_form-success')
                        .addClass('_form-error _form-message');

                    if (this.$form.hasClass('js-hotline-form')) {
                        this.$form.addClass('_not-found');
                        this.$form.find('.js-hotline-empty').html(response.message);
                    }

                    this.$form.find('.js-ajax-error').html(response.message).show();
                    this.$form.trigger('form:error', response);
                } else {
                    // Успех!
                    this.resetForm();
                    this.$form.find('.js-ajax-error').html('').hide();

                    this.$form
                        .addClass('_success')
                        .removeClass('_error');
                    App.H
                        .removeClass('_form-error')
                        .addClass('_form-success _form-message');
                    this.$form.trigger('form:success', response);

                    if (this.$form.hasClass('js-ya-form-submit')) {
                        const pageUrl = `${location.protocol}//${location.host}${location.pathname}`;
                        ym(23799535, 'reachGoal', 'form',
                            {
                                form: {
                                    eventCategory: 'form',
                                    eventAction: 'send',
                                    eventLabel: 'success',
                                    url: pageUrl
                                }
                            }
                        );
                    }

                    if (this.$form.hasClass('js-hotline-form')) {
                        $('.js-hotline-ticket').html(response.ticket);

                        const $ticketText = $('.js-hotline-ticket').find('.js-ticket-text');
                        const minHeightTicketText = 35;
                        const screenS = 767;
                        if ($ticketText.innerHeight() < minHeightTicketText && $(window).width > screenS) {
                            $('.js-ticket-text').removeClass('_shown');
                            $('.js-ticket-more').addClass('_hidden');
                        }

                        if (response.needAnswer) {
                            $('.js-hotline-answer').addClass('_shown');
                        }
                    }

                    if (this.$form.hasClass('js-hotline-submit')) {
                        $('.js-hotline-code').text(response.code);
                    }
                }

                // Разблокируем кнопку
                this.$btn.removeAttr('disabled');
            },
            error: () => {
                // Ошибка отправки
                const errorMessageList = {
                    ru: 'Ошибка отправки формы',
                    en: 'Form submission error'
                };
                const errorMessage = errorMessageList[App.H.attr('lang')] || errorMessageList.en;

                App.H
                    .removeClass('_form-success')
                    .addClass('_form-error _form-message');

                this.$form.find('.js-ajax-error').html(errorMessage).show();
                this.$form.trigger('form:error', {
                    success: false,
                    message: `<p class="description">${errorMessage}</p>`
                });

                // Разблокируем кнопку
                this.$btn.removeAttr('disabled');

                // Автоматически закрываем сообщения
                // setTimeout(() => {
                // this.$form.removeClass('_success _error');
                // }, 5000);
            }
        });
    }



    // Закрытие формы
    bindClose() {
        App.H
            .find('.js-form-ok')
            .on('click', function (e) {
                e.preventDefault();
                App.H.removeClass('_form-success _form-error _form-message');
            });
    }



    // Загрузка файла
    fileUpload() {
        this.$form.find('.js-upload').closest('.file-input').each((i, fileDom) => {
            this.fileUploadSingleRender(fileDom);
        });

        this.$form.find('.js-upload').closest('.files-inputs').each((i, filesDom) => {
            this.fileUploadMulti(filesDom);
        });
    }

    fileUploadMulti(filesRootDom) {
        const $input = $(filesRootDom).find('.files-input');
        const template = $input[0].outerHTML;

        this.fileUploadMultiRender($input[0], template, filesRootDom);
    }

    fileUploadMultiRender (fileDom, template, filesRootDom) {
        const $file = $(fileDom);
        const $input = $file.find('.js-upload');
        const $label = $file.find('.js-upload-label');
        const $filesRoot = $(filesRootDom);
        const required = $input.is('[data-required]');

        $label.on('click', () => {
            $input.val('').removeClass('_active');
            $label.html($label.data('text'));
            $label.siblings('.form__label').text('');

            if (!$input.val()) {
                $label.off('click');
                $input.off('change');
                $file.remove();
            }

            if (required) {
                this.formValidate.addInputs($filesRoot.find('.files-input .js-upload').eq(0).attr('data-required', ''));
                $filesRoot.find('.files-input .js-upload').eq(0).trigger('removed');
            }
        });

        $input
            .on('change', () => {
                const val = $input.val();
                let fileName;

                if (val.length) {
                    fileName = val.split('\\').pop() || '';
                    $label.text(fileName);
                    $input.addClass('_active');
                } else {
                    $label.text($label.data('text'));
                    $input.removeClass('_active');
                }

                const $newInputs = this.fileUploadMultiRender($(template), template, filesRootDom);

                $filesRoot.append($newInputs);
                if (required) {
                    $newInputs
                        .find('[data-required]')
                        .removeAttr('data-required')
                        .removeClass('_notvalidated');
                }
                this.formValidate.addInputs($newInputs);
            });

        return $file;
    }

    fileUploadSingleRender(fileDom) {
        const $file = $(fileDom);

        $file.find('.js-upload-label').on('click', function () {
            const $fileLabel = $(this);

            $fileLabel.siblings('.js-upload').val('').removeClass('_active');
            $fileLabel.html($fileLabel.data('text'));
            $fileLabel.siblings('.form__label').text('');
        });

        $file
            .find('.js-upload')
            .on('change', function () {
                const $input = $(this);
                const $label = $input.closest('.input-wrap').find('.js-upload-label');
                const val = $input.val();
                let fileName;

                if (val.length) {
                    fileName = val.split('\\').pop() || '';
                    $label.text(fileName);
                    $input.addClass('_active');
                } else {
                    $label.text($label.data('text'));
                    $input.removeClass('_active');
                }
            });


        $file
            .find('.js-upload-clear')
            .on('click', function () {
                $(this).siblings('.js-upload').val('').change();
            });
    }



    // Для поля телефона допускаем только цифры, пробел и +-()
    filterPhone() {
        this.$form.find('[data-phone]').on('input', function () {
            const val = $(this).val().replace(/[^0-9\s()+-]/g, '');

            $(this).val(val);
        });
    }



    // Для поля допускающих только цифры
    filterDigit() {
        this.$form.find('[data-digit]').on('input', function () {
            let val = $(this).val().replace(/[^0-9]/g, '');

            if ($(this).data('digit') == 'divide') {
                val = numberDivide(val);
            }

            $(this).val(val);
        });
    }



    // Сброс формы
    resetForm() {
        this.$form[0].reset();

        this.$form
            .find('.js-upload')
            .val('')
            .change()
            .siblings('[data-label]')
            .text('');

        this.$form
            .find('.files-inputs .files-input:not(:first-child)')
            .remove();

        this.$form.removeClass('_success _error');

        this.$form
            .find('[data-required]')
            .not(':checkbox')
            .addClass('_notvalidated')
            .removeClass('_error');

        this.$form
            .find(':checkbox[data-required]')
            .not(':checked')
            .addClass('_notvalidated');

        /*this.$form
            .find('.js-submit')
            .attr('disabled', true);*/

        this.$form
            .find('.js-input-wrap')
            .removeClass('_focused');

        this.$form
            .find('.js-dropdown')
            .trigger('dropdown:reset');

        this.$form
            .find('.js-multiselect')
            .trigger('multiselect:reset');

        this.$form
            .trigger('reset');

        if (App.recaptchaAvailable) {
            grecaptcha.reset(this.recaptcha);
        }
    }



    // Подсказки для инпутов
    popLabels() {
        this.$form
            .find('input.js-input, textarea.js-input')
            .on('input blur', function () {
                const val = $.trim($(this).val());

                if (!val.length || val == '+7() --') {
                    $(this).closest('.js-input-wrap').removeClass('_focused');
                } else {
                    $(this).closest('.js-input-wrap').addClass('_focused');
                }
            });
    }



    // Отключаем автозаполнение полей в хроме
    disableAutoFill() {
        this.$form
            .find('[type="text"], [type="email"], [type="tel"], [type="password"]')
            .attr('autocomplete', 'new-password');
    }



    // Фикс autocomplete="off" для IE и Edge
    disableIEautocomplete() {
        if (App.ie || App.edge) {
            window.onbeforeunload = function () {
                $('form[autocomplete="off"]').each(function () {
                    this.reset();
                });
            };
        }
    }



    // Защита от спама (если нет рекапчи)
    spamCheck() {
        App.secondsOnPage = 0;
        // Проверка phantomJS
        let isBot = function () {
            var retval = false;

            if (window._phantom || window.callPhantom) retval = true;
            if (window.__phantomas) retval = true; //PhantomJS-based web perf metrics + monitoring tool
            if (window.Buffer) retval = true; //nodejs
            if (window.emit) retval = true; //couchjs
            if (window.spawn) retval = true;  //rhino
            if (window.webdriver) retval = true; //selenium
            if (window.domAutomation || window.domAutomationController) retval = true; //chromium based automation driver
            // if (window.outerWidth === 0 && window.outerHeight === 0) retval = true; //headless browser

            return retval;
        };

        if (isBot()) {
            return false;
        }

        // Считаем, сколько времени пользователь провёл на сайте, и отправляем это в форме
        let name = this.$form.data('name');

        this.$form.append(`<input type="hidden" name="${name}" class="js-input-seconds" value="0" />`);

        clearInterval(App.antispamTimeout);
        App.antispamTimeout = setInterval(() => {
            App.secondsOnPage++;
            //this.$form.find(`.js-input-seconds`).val(App.secondsOnPage);
        }, 1000);
    }


    // Клонируемые блоки
    initClonable() {
        const $list = this.$form.find('.input-wrap-clonable-list');

        $list.each((i, listDom) => {
            const $clonable = $('.input-wrap-clonable', listDom);
            const template = $clonable[0].outerHTML;

            this.renderClonable($clonable, template, $list[0]);
        });
    }

    renderClonable(clonableDom, template, rootDom) {
        const $clonable = $(clonableDom);

        $('.js-clonable-add', $clonable).on('click', () => {
            const $newClone = $(template);

            $(rootDom).append(this.renderClonable($newClone, template, rootDom));

            this.formValidate.addInputs($newClone.find('input'));

            $('.js-clonable-remove', $newClone).on('click', () => {
                $newClone.remove();
            });
        });

        return $clonable;
    }

    // мультиселект
    multiselect() {
        $('.js-multiselect', this.$form).each((i, selectDom) => {
            this.renderMultiselect(selectDom);
        });
    }

    // селект
    singleselect() {
        $('select.js-input', this.$form).each((i, selectDom) => {
            const $select = $(selectDom);

            if ($select.is(':not([multiple])')) {
                if (!$select.val()) {
                    $select.addClass('_placeholder');
                }

                $select
                    .one('change', () => {
                        $select.removeClass('_placeholder');
                    })
                    .on('focus mousedown', (e) => {
                        $(e.target).parent().addClass('_focus');
                    })
                    .on('blur change', (e) => {
                        $(e.target).parent().removeClass('_focus');
                    });
            }
        });
    }

    renderMultiselect(selectDom) {
        const $select = $(selectDom);
        const $control = $select.parent().find('.form__multiselect-control');
        const $list = $control.parent().find('.form__multiselect-control-list');
        const $inner = $('.form__multiselect-control-inner', $control);
        const $scrollbar = $('.scrollbar-inner', $control);
        const placeholder = $control.data('placeholder');
        const decl = $control.data('decl');
        const empty = $control.data('empty');

        $scrollbar.html(Array.from($select[0].options).map((option) => {
            return `<div class="option" data-value='${option.value}'>${$select.find(`[value='${option.value}']`).text()}</div>`;
        }).join(''));

        $scrollbar.scrollbar();

        $control.on('click', (e) => {
            if (!$(e.target).closest('.scrollbar-inner').length) {
                $control.toggleClass('_collapsed');
                $control.closest('.select-wrap').toggleClass('_focus', $control.hasClass('_collapsed'));
            }
        });

        App.B.on('mouseup', (e) => {
            if (!$(e.target).closest($control.parent()).length) {
                $select.trigger('multiselect:reset');
            }
        });

        $select.on('multiselect:reset', () => {
            $control.removeClass('_collapsed');
            $control.closest('.select-wrap').removeClass('_focus');
            update();
        });

        $control.on('click', '.option', (e) => {
            const $option = $(e.target);

            $option.toggleClass('_active');

            if ($option.hasClass('_active')) {
                $select.find(`[value='${$option.attr('data-value')}']`).prop('selected', true);
            } else {
                $select.find(`[value='${$option.attr('data-value')}']`).prop('selected', false);
            }

            $select.trigger('change');
        });

        $list.on('click', '.option', (e) => {
            const $option = $(e.target);

            $select.find(`[value='${$option.attr('data-value')}']`).prop('selected', false);
            $select.trigger('change');
        });

        $select.on('change', update);

        update();

        function update() {
            $control
                .find('.option')
                .removeClass('_active');

            $select.val().forEach(value => {
                $control
                    .find(`.option[data-value='${value}']`)
                    .addClass('_active');
            });

            $list[0].innerHTML = $inner.find('.option').parent()[0].innerHTML;

            const newPlaceholder = placeholder.replace(/\${([^ ]*)}/g, (match, decl) => {
                return decl == 'count' ? $select.val().length : declOfNum($select.val().length, $control.data(decl));
            });

            $control.attr('data-placeholder', $select.val().length ? newPlaceholder : empty);
        }
    }

    // сумма площадей
    areasum() {
        const $root = $('.js-area-sum', this.$form);
        const $inputs = $('.js-input', $root);
        const $total = $('.js-area-sum-total', $root);

        if ($root.length) {
            $inputs.on('input', () => {
                $total.html(Array.from($inputs.filter(':visible')).reduce((sum, input) => {
                    return sum + Number(input.value || 0);
                }, 0));
            });

            $('.js-area-sum-select').on('change init', () => {
                requestAnimationFrame(() => {
                    $('.input-wrap', $root).toggleClass('_has-delimiter', $('.input-wrap:visible', $root).length != 1);
                    $inputs.trigger('input');
                });
            });
        }
    }

    // показать/скрыть блоки используя radio
    bindRadioShowHide() {
        this.$form.find('[type="radio"][data-show]').each((i, radioDom) => {
            const $radioList = this.$form.find(`[type="radio"][name="${radioDom.name}"]`);

            $radioList.on('change init', () => {
                $radioList.each((i, radioDom) => {
                    const $radio = $(radioDom);
                    const selector = $radio.attr('data-show');

                    $(selector).toggle($radio.prop('checked'));
                });
            }).trigger('init');
        });
    }

    // показать/скрыть блоки используя select
    bindSelectShowHide() {
        this.$form.find('select option[data-show]').parent().on('change init', e => {
            const $select = $(e.currentTarget);
            const $options = $select.find('[data-show]');

            $options.each((i, option) => {
                $($(option).attr('data-show')).hide();
            });

            $options.filter('[data-show]:selected').each((i, option) => {
                $($(option).attr('data-show')).show();
            });
        }).trigger('init');
    }

    bindSuccessPopup() {
        $('.js-form-reset').on('click', () => {
            this.$form.removeClass('_success _error');
            App.H.removeClass('_form-success _form-message');
            App.lockScroll.unlock();
        });

        if (this.$form.closest('.supplier-form').length) {
            this.$form.on('form:success', () => {
                App.lockScroll.lock();
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(
                    {
                        "event": "form_submit"
                    }
                );
            });
        }
    }

    renderFormState() {
        const $form = this.$form;
        const $root = $('.js-form-state');
        const $sections = $('[data-form-state]', $root);

        $form.on('reset', () => {
            $('.js-form-state-progress', $root).css('width', '');
        });

        $form.on('change removed', '[data-required]', (e) => {
            update(e.currentTarget);
        });

        function update(fieldChanged) {
            const $fieldChanged = $(fieldChanged);
            let id;
            if ($fieldChanged.is('[type="radio"]')) {
                id = $(`[type="radio"][name="${$fieldChanged[0].name}"]`, $form).filter('[data-form-state]').eq(0).data('form-state');
            } else {
                id = $fieldChanged.data('form-state');
            }
            const $section = $sections.filter(`[data-form-state="${id}"]`);
            const $progress = $('.js-form-state-progress', $section);
            const $fields = $(`[data-required][data-form-state="${id}"]:visible`, $form).filter((i, fieldDom) => {
                if ($(fieldDom).is('[type="radio"]')) {
                    const $radios = $(`[name="${fieldDom.name}"]`, $form);

                    if ($radios.filter(':checked').length) {
                        return $(fieldDom).prop('checked');
                    } else {
                        return $(fieldDom).is(':first-child');
                    }
                } else {
                    return true;
                }
            });
            const $filled = $fields.filter((i, fieldDom) => {
                const $field = $(fieldDom);
                const hasError = $field.hasClass('_error');

                if ($field.is('input[type="radio"]')) {
                    return $field.prop('checked') && !hasError;
                } else
                if ($field.is('input[type="checkbox"]')) {
                    return $field.prop('checked') && !hasError;
                } else
                if ($field.is('input[type="file"]')) {
                    return $field.val().length && !hasError;
                } else
                if ($field.is('input')) {
                    return $field.val() && !hasError;
                } else
                if ($field.is('select[multiple]')) {
                    return $field.val().length && !hasError;
                } else
                if ($field.is('select')) {
                    return $field.val() && !hasError;
                }
            });

            $progress.css('width', `${$filled.length / $fields.length * 100}%`);
        }
    }
}

const $forms = $('.js-form');

if ($forms.length) {
    if (App.recaptchaAvailable) {
        App.W.on('grecaptchaLoaded', function () {
            $forms.each(function () {
                new Form(this);
            });
        });
    } else {
        $forms.each(function () {
            new Form(this);
        });
    }
}



// WEBPACK FOOTER //
// ./_src/js/Form.js